import {P_LIST_TYPES} from '../../../constants/typesMessages';
import {removeMask} from '../../../utils';

/**
 * EC without data partners from Bureaus
 * ...
 */

export const informNumberPartners = (inputValue) => {
  let numb = Number.parseInt(removeMask(inputValue), 10);
  if (numb > 0) {
    return {
      status: true,
      numbPartners: numb
    };
  }

  return {
    status: false,
    numbPartners: numb,
    error: {
      messages: [
        {
          text: 'Por favor, digite um numero inteiro positivo.',
          type: 'message-receive'
        }
      ]
    }
  };
};

export const setNumberPartners = (
  partnerVd,
  partnerNumb,
  typePartner,
  partnerList
) => {
  let partners = [];
  let partSelected = {id: 1};

  if (
    typePartner === P_LIST_TYPES.P_OWNER ||
    typePartner === P_LIST_TYPES.P_OWN_HAS_PART
  ) {
    // Add partner data from user details
    partSelected = {id: 2};
    partnerVd.numbPartners += 1;
    partners.push(partnerList[0]);
  }

  for (let i = partnerList.length; i < partnerVd.numbPartners; i++) {
    partners.push({
      id: i + 1
    });
  }

  let messages = [
    {
      text: partnerNumb,
      type: 'response-sent'
    }
  ];

  return {
    messages,
    partners,
    partnerSelected: partSelected,
    partnerNumb,
    responseType: 'partner-name'
  };
};
